import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { requestVideoPlayerPlaybackRate } from 'actions/videoPlayer';
import * as analytics from 'utilities/analytics';
import { store } from 'utilities/store';

import { PLAYBACK_RATES, PLAYBACK_RATES_MAP } from '../../constants/playback';
import { START_SCREEN_SPEED_SELECTOR_CLICK } from '../../../../constants/events';

import './styles.less';

export default function PlayScreen() {
  const {
    full_screen: fullScreen,
    theater_mode: theaterMode,
    playback_rate: playbackRate,
  } = useSelector(state => state.video_player);

  function onRateClick(event, rate) {
    event.stopPropagation();
    analytics.track(START_SCREEN_SPEED_SELECTOR_CLICK, { rate });
    store.dispatch(requestVideoPlayerPlaybackRate(rate));
  }

  return (
    <div
      className={classNames(
        'play-screen-speed-selector-container',
        (theaterMode || fullScreen) && 'large-format'
      )}
    >
      <div className="button-indicator-container">
        <div className="relative-indicator-el">
          <div
            className={`button-indicator-${PLAYBACK_RATES.indexOf(
              playbackRate
            )}`}
          />
        </div>
      </div>
      {PLAYBACK_RATES_MAP.map(rateObj => {
        return (
          <div
            key={rateObj.rate}
            className={classNames(
              'speed-button',
              playbackRate == rateObj.rate && 'speed-button-selected'
            )}
            onClick={event => onRateClick(event, rateObj.rate)}
          >
            {rateObj.display}
          </div>
        );
      })}
    </div>
  );
}
